module.exports = __webpack_public_path__ + "fontawesome-webfont.a35720c2fed2c7f043bc.woff";


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/assets/fonts/fontawesome-webfont.woff
// module id = ../../../../../src-admin/assets/fonts/fontawesome-webfont.woff
// module chunks = styles